import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Tabs,
    Tab,
    Button,
    Grid,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Divider,
    IconButton,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Pagination
} from '@mui/material';
import { Store } from 'react-notifications-component';
import {
    AddCircleOutline as AddIcon,
    CheckCircle as AcceptedIcon,
    Cancel as RejectedIcon,
    Send as SentIcon,
    Business as BrandIcon,
    CloudUpload as UploadIcon,
    InfoOutlined as InfoIcon,
    LibraryBooks as SectionIcon,
    Visibility as ViewIcon,
    FilePresent as FileIcon,
    AssignmentLate as ObsIcon,
    WarningAmber as WarningIcon,
    ErrorOutline as ErrorIcon,
    History as HistoryIcon,
    TrendingUp as TrendingIcon,
    AccountBalance as BalanceIcon,
    Description as DescriptionIcon,
    Search as SearchIcon,
    FilterList as FilterIcon
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { registrarSolicitud, obtenerSolicitudes, actualizarSolicitud } from '../../../redux/DucksBeneficiario/InformacionComercialDucks';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';

const InformacionComercial = () => {
    const [tabValue, setTabValue] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    console.log('los datos de select es ', selectedBrand)
    console.log('selectedBrand ', selectedBrand)
    const [isEditing, setIsEditing] = useState(false);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch()
    const currentUser = useSelector(store => store.Usuario.data)
    const { solicitudes, pagination, loading: loadingInfo } = useSelector(store => store.informacionComercial)
    console.log('solicitudes ', solicitudes)
    const [cliente, setCliente] = useState(null)
    console.log('cliente ', cliente)
    const [formData, setFormData] = useState({
        id_marca_cliente: '',
        tipoSolicitud: '',
        comentarios: '',
        motivos: {
            cambioPresentacion: false,
            cambioPais: false,
            cambioDestino: false,
            otros: false
        },
        documentos: [],
        pagoPdf: null,
        etiquetasPdf: null
    });


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setPage(1); // Reset to first page when changing tabs
    };

    const handleOpenModal = () => {
        setIsEditing(false);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEditing(false);
        setFormData({
            id_marca_cliente: '',
            tipoSolicitud: '',
            comentarios: '',
            motivos: {
                cambioPresentacion: false,
                cambioPais: false,
                cambioDestino: false,
                otros: false
            },
            documentos: [],
            pagoPdf: null,
            etiquetasPdf: null
        });
    };

    const handleOpenDetailModal = (brand) => {
        setSelectedBrand(brand);
        setOpenDetailModal(true);
    };

    const handleCloseDetailModal = () => {
        setOpenDetailModal(false);
        setSelectedBrand(null);
    };

    const handleEditRequest = (brand) => {
        setFormData({
            id_marca_cliente: brand.id_marca_cliente || '',
            tipoSolicitud: brand.tipo_informe,
            comentarios: brand.comentarios_adicionales,
            motivos: {
                cambioPresentacion: brand.cambio_presentacion || false,
                cambioPais: brand.cambio_pais || false,
                cambioDestino: brand.cambio_destino || false,
                otros: brand.otros || false,
            },
            documentos: [],
            pagoPdf: null,
            etiquetasPdf: null
        });
        setOpenModal(true);
        setIsEditing(true);
        setOpenDetailModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            motivos: {
                ...prev.motivos,
                [name]: checked
            }
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        if (file) {
            const newDoc = {
                tipo_documento: name === 'pagoPdf' ? 'COMPROBANTE_PAGO' : 'JUEGO_ETIQUETAS',
                nombre_archivo: file.name,
                url_archivo: `temp_url_${file.name}`
            };
            setFormData(prev => ({
                ...prev,
                [name]: file, // Guardamos el objeto archivo para mostrar el nombre
                documentos: [...prev.documentos.filter(d => d.tipo_documento !== newDoc.tipo_documento), newDoc]
            }));
        }
    };

    const handleSubmit = async () => {
        if (isEditing && selectedBrand) {
            // --- Modo EDICIÓN: actualizar solicitud existente (multipart/form-data) ---
            const data = new FormData();
            data.append('id_marca_cliente', formData.id_marca_cliente);
            data.append('tipo_informe', formData.tipoSolicitud);
            data.append('comentarios_adicionales', formData.comentarios);
            data.append('cambio_presentacion', formData.motivos.cambioPresentacion);
            data.append('cambio_pais', formData.motivos.cambioPais);
            data.append('cambio_destino', formData.motivos.cambioDestino);
            data.append('otros', formData.motivos.otros);
            data.append('estatus', 'CORREGIDA');
            // Adjuntar archivos si se seleccionaron nuevos
            if (formData.pagoPdf) {
                data.append('COMPROBANTE_PAGO', formData.pagoPdf);
            }
            if (formData.etiquetasPdf) {
                data.append('JUEGO_ETIQUETAS', formData.etiquetasPdf);
            }
            try {
                await dispatch(actualizarSolicitud({
                    id_solicitud: selectedBrand.id_solicitud,
                    formData: data
                })).unwrap();

                Store.addNotification({
                    title: "Solicitud Actualizada",
                    message: "La solicitud ha sido actualizada y re-enviada correctamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeInRight"],
                    animationOut: ["animate__animated", "animate__fadeOutRight"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                handleCloseModal();
                // Refrescar la lista
                const statusMap = { 0: 'NUEVA', 1: 'RECHAZADA', 2: 'AUTORIZADA' };
                dispatch(obtenerSolicitudes({
                    estatus: statusMap[tabValue],
                    id_login: currentUser.user[0].id,
                    page: page,
                    limit: 6
                }));
            } catch (error) {
                console.error("Error al actualizar solicitud:", error);
                Store.addNotification({
                    title: "Error al Actualizar",
                    message: "Ocurrió un error al intentar actualizar la solicitud.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeInRight"],
                    animationOut: ["animate__animated", "animate__fadeOutRight"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } else {
            // --- Modo CREACIÓN: nueva solicitud ---
            const data = new FormData();
            data.append('id_marca_cliente', formData.id_marca_cliente);
            data.append('tipo_informe', formData.tipoSolicitud);
            data.append('comentarios_adicionales', formData.comentarios);
            data.append('id_login', currentUser.user[0].id);
            data.append('cambio_presentacion', formData.motivos.cambioPresentacion);
            data.append('cambio_pais', formData.motivos.cambioPais);
            data.append('cambio_destino', formData.motivos.cambioDestino);
            data.append('otros', formData.motivos.otros);
            if (formData.pagoPdf) {
                data.append('COMPROBANTE_PAGO', formData.pagoPdf);
            }
            if (formData.etiquetasPdf) {
                data.append('JUEGO_ETIQUETAS', formData.etiquetasPdf);
            }
            try {
                await dispatch(registrarSolicitud(data)).unwrap();
                Store.addNotification({
                    title: "Solicitud Enviada",
                    message: "La solicitud ha sido enviada correctamente. Su marca ha sido registrada.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeInRight"],
                    animationOut: ["animate__animated", "animate__fadeInRight"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                handleCloseModal();
            } catch (error) {
                console.error("Error al registrar solicitud:", error);
                Store.addNotification({
                    title: "Error al Enviar",
                    message: "Ocurrió un error al intentar enviar la solicitud.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeInRight"],
                    animationOut: ["animate__animated", "animate__fadeOutRight"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        }
    };


    const getStatusIcon = (status) => {
        switch (status) {
            case 'AUTORIZADA': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e8f5e9', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <AcceptedIcon sx={{ color: '#4caf50', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 'bold' }}>Autorizada</Typography>
                </Box>
            );
            case 'RECHAZADA': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#ffebee', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <RejectedIcon sx={{ color: '#f44336', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#f44336', fontWeight: 'bold' }}>Rechazada</Typography>
                </Box>
            );
            case 'NUEVA': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e3f2fd', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <SentIcon sx={{ color: '#2196f3', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#2196f3', fontWeight: 'bold' }}>Nueva</Typography>
                </Box>
            );
            case 'EN_REVISION': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#fff3e0', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <HistoryIcon sx={{ color: '#ff9800', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#ff9800', fontWeight: 'bold' }}>En Revisión</Typography>
                </Box>
            );
            case 'CORREGIDA': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#f3e5f5', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <UploadIcon sx={{ color: '#9c27b0', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#9c27b0', fontWeight: 'bold' }}>Corregida</Typography>
                </Box>
            );
            default: return null;
        }
    };
    React.useEffect(() => {
        const fetchInitialData = async () => {
            if (currentUser?.user?.[0]?.id) {
                try {
                    // Fetch cliente
                    const clienteData = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id)).unwrap();
                    setCliente(clienteData?.cliente[0]);
                } catch (error) {
                    console.error("Error al obtener datos iniciales:", error);
                }
            }
        };
        fetchInitialData();
    }, [dispatch, currentUser]);

    const marcasCombinadas = [
        ...(cliente?.marcascliente?.map(m => ({ ...m, tipo: 'Mezcal' })) || []),
        ...(cliente?.marcasproductoconmezcalcliente?.map(m => ({ ...m, tipo: 'Bebida con Mezcal' })) || [])
    ];

    React.useEffect(() => {
        if (currentUser?.user?.[0]?.id) {
            // Map tabValue to status (1: Enviada, 3: Rechazada, 2: Aceptada)
            const statusMap = {
                0: 'NUEVA',      // Enviadas/Nuevas
                1: 'RECHAZADA',  // Rechazadas
                2: 'AUTORIZADA'  // Aceptadas/Autorizadas
            };
            dispatch(obtenerSolicitudes({
                estatus: statusMap[tabValue],
                id_login: currentUser.user[0].id,
                page: page,
                limit: 6
            }));
        }
    }, [dispatch, currentUser, tabValue, page]);


    return (
        <div className='container2 animate__animated animate__fadeIn'>
            <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {/* --- HERO SECTION --- */}
                <Box sx={{
                    mb: 4,
                    p: 4,
                    borderRadius: 4,
                    background: 'linear-gradient(135deg, #2b2b2b 0%, #444444 100%)',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
                }}>
                    <Box sx={{ position: 'relative', zIndex: 1 }}>
                        <Typography variant="h3" sx={{ fontWeight: 800, mb: 1, letterSpacing: '-0.02em' }}>
                            Información Comercial
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.8, fontWeight: 400, mb: 3, maxWidth: '600px' }}>
                            Gestiona y monitorea tus solicitudes de informes comerciales de manera eficiente y segura.
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={handleOpenModal}
                            sx={{
                                backgroundColor: '#c88b3e',
                                '&:hover': { backgroundColor: '#a67332', transform: 'translateY(-2px)' },
                                borderRadius: '30px',
                                px: 4,
                                py: 1.5,
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                textTransform: 'none',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: '0 4px 15px rgba(200, 139, 62, 0.4)'
                            }}
                        >
                            Solicitar Nuevo Informe
                        </Button>
                    </Box>
                    {/* Decorative element */}
                    <Box sx={{
                        position: 'absolute',
                        right: -50,
                        top: -50,
                        width: 300,
                        height: 300,
                        borderRadius: '50%',
                        background: 'rgba(200, 139, 62, 0.1)',
                        zIndex: 0
                    }} />
                </Box>

                <Paper elevation={0} sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', backgroundColor: 'white' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#2b2b2b' }}>
                            Listado de Solicitudes
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {/* Potential search bar area */}
                        </Box>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{
                            mb: 4,
                            borderBottom: '1px solid #eee',
                            '& .MuiTabs-indicator': { backgroundColor: '#c88b3e', height: 3, borderRadius: '3px 3px 0 0' },
                            '& .Mui-selected': { color: '#c88b3e !important', fontWeight: 700 },
                            '& .MuiTab-root': { textTransform: 'none', fontSize: '1rem', minWidth: 120, color: '#666' }
                        }}
                    >
                        <Tab label="Enviadas" icon={<SentIcon style={{ fontSize: 20 }} />} iconPosition="start" />
                        <Tab label="Rechazadas" icon={<RejectedIcon style={{ fontSize: 20 }} />} iconPosition="start" />
                        <Tab label="Aceptadas" icon={<AcceptedIcon style={{ fontSize: 20 }} />} iconPosition="start" />
                    </Tabs>

                    <Grid container spacing={3}>
                        {solicitudes && solicitudes.length > 0 ? (
                            solicitudes.map((brand, index) => (
                                <Grid item xs={12} sm={6} md={4} key={brand.id_solicitud || index}>
                                    <Card sx={{
                                        height: '100%',
                                        borderRadius: 3,
                                        border: '1px solid #f0f0f0',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        position: 'relative',
                                        '&:hover': {
                                            transform: 'translateY(-8px)',
                                            boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
                                            borderColor: '#c88b3e33'
                                        }
                                    }}>
                                        <CardContent sx={{ p: 3 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                                <Box sx={{
                                                    p: 1,
                                                    borderRadius: 2,
                                                    background: 'linear-gradient(45deg, #fdfbfb 0%, #ebedee 100%)',
                                                    color: '#c88b3e'
                                                }}>
                                                    <BrandIcon fontSize="large" />
                                                </Box>
                                                {getStatusIcon(brand.estatus)}
                                            </Box>

                                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#2b2b2b', mb: 0.5, lineHeight: 1.2 }}>
                                                {brand.nombre_marca || 'Marca no identificada'}
                                            </Typography>

                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                <Chip
                                                    label={brand.tipo_marca}
                                                    size="small"
                                                    sx={{
                                                        height: 20,
                                                        fontSize: '0.65rem',
                                                        fontWeight: 700,
                                                        backgroundColor: '#f5f5f5',
                                                        color: '#666'
                                                    }}
                                                />
                                            </Box>

                                            <Divider sx={{ my: 2, borderStyle: 'dashed' }} />

                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Folio</Typography>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#444' }}>{brand.folio}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Fecha</Typography>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#444' }}>{new Date(brand.fecha_creacion).toLocaleDateString()}</Typography>
                                                </Grid>
                                            </Grid>

                                            <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
                                                    {brand.tipo_informe}
                                                </Typography>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    startIcon={<ViewIcon />}
                                                    onClick={() => handleOpenDetailModal(brand)}
                                                    sx={{
                                                        color: '#c88b3e',
                                                        borderColor: '#c88b3e',
                                                        borderRadius: '15px',
                                                        textTransform: 'none',
                                                        fontWeight: 700,
                                                        '&:hover': { backgroundColor: '#c88b3e', color: 'white', borderColor: '#c88b3e' }
                                                    }}
                                                >
                                                    Detalles
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Box sx={{ textAlign: 'center', py: 5 }}>
                                    <Typography variant="h6" color="textSecondary">
                                        No hay registros en esta categoría.
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>

                    {pagination && pagination.totalPages > 1 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                            <Pagination
                                count={pagination.totalPages}
                                page={page}
                                onChange={(e, value) => setPage(value)}
                                sx={{
                                    '& .MuiPaginationItem-root.Mui-selected': {
                                        backgroundColor: '#c88b3e',
                                        color: 'white',
                                        '&:hover': { backgroundColor: '#a67332' }
                                    }
                                }}
                            />
                        </Box>
                    )}
                </Paper>

                {/* Modal para solicitar informe */}
                <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
                    <DialogTitle sx={{
                        background: 'linear-gradient(45deg, #2b2b2b 30%, #444444 90%)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        py: 2
                    }}>
                        {isEditing ? <WarningIcon sx={{ color: '#c88b3e' }} /> : <AddIcon sx={{ color: '#c88b3e' }} />}
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {isEditing ? 'Corregir Solicitud' : 'Solicitar Nuevo Informe'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ mt: 1, p: 3 }}>
                        {isEditing && selectedBrand?.estatus === 'RECHAZADA' && selectedBrand.solicitud_validacion_resultados && (
                            <Box sx={{ mb: 3, p: 2, backgroundColor: '#fff5f5', border: '1px solid #ffcdd2', borderRadius: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                    <ErrorIcon sx={{ color: '#f44336', fontSize: 18 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                        OBSERVACIONES POR CORREGIR
                                    </Typography>
                                </Box>
                                <Box sx={{ pl: 3 }}>
                                    {selectedBrand.solicitud_validacion_resultados
                                        .filter(r => r.cumple == false)
                                        .map((rev, idx) => (
                                            <Typography key={idx} variant="caption" display="block" sx={{ color: '#d32f2f', mb: 0.5 }}>
                                                • <strong>Observación {idx + 1}:</strong> {rev.observacion}
                                            </Typography>
                                        ))
                                    }
                                </Box>
                            </Box>
                        )}
                        <Grid container spacing={2.5}>
                            {/* Sección: Información General */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                    <BrandIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        INFORMACIÓN GENERAL
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Seleccionar Marca"
                                    name="id_marca_cliente"
                                    value={formData.id_marca_cliente}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                >
                                    {marcasCombinadas.map((m, index) => (
                                        <MenuItem key={m.idmarcascliente || m.id_marca_cliente || index} value={m.idmarcascliente || m.id_marca_cliente}>
                                            {m.marca} ({m.tipo})
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Tipo de Informe"
                                    name="tipoSolicitud"
                                    value={formData.tipoSolicitud}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                >
                                    <MenuItem value="Nacional">Nacional</MenuItem>
                                    <MenuItem value="Exportación">Exportación</MenuItem>
                                </TextField>
                            </Grid>

                            {/* Sección: Motivo de Revisión */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1, gap: 1 }}>
                                    <InfoIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        MOTIVO DE REVISIÓN
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 1 }} />
                                <FormControl component="fieldset" variant="standard" fullWidth>
                                    <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <Grid container>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.cambioPresentacion} onChange={handleCheckboxChange} name="cambioPresentacion" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Cambio de presentación</Typography>}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.cambioPais} onChange={handleCheckboxChange} name="cambioPais" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Cambio de país</Typography>}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.cambioDestino} onChange={handleCheckboxChange} name="cambioDestino" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Cambio de destino</Typography>}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.otros} onChange={handleCheckboxChange} name="otros" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Otros</Typography>}
                                                />
                                            </Grid>
                                        </Grid>
                                    </FormGroup>
                                </FormControl>
                            </Grid>

                            {/* Sección: Documentación */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1, gap: 1 }}>
                                    <UploadIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        DOCUMENTACIÓN Y ADJUNTOS
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>

                            {(formData.motivos.cambioPresentacion || formData.motivos.cambioPais || formData.motivos.cambioDestino) && (
                                <Grid item xs={12}>
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        fullWidth
                                        startIcon={<UploadIcon />}
                                        sx={{
                                            textTransform: 'none',
                                            justifyContent: 'flex-start',
                                            borderColor: '#e0e0e0',
                                            color: '#333',
                                            py: 1.5,
                                            '&:hover': { borderColor: '#c88b3e', backgroundColor: 'rgba(200, 139, 62, 0.04)' }
                                        }}
                                    >
                                        <Box sx={{ textAlign: 'left', width: '100%' }}>
                                            <Typography variant="caption" display="block" color="textSecondary">
                                                Comprobante de Pago (PDF)
                                            </Typography>
                                            <Typography variant="body2" noWrap>
                                                {formData.pagoPdf ? formData.pagoPdf.name : 'Subir archivo...'}
                                            </Typography>
                                        </Box>
                                        <input type="file" hidden accept="application/pdf" name="pagoPdf" onChange={handleFileChange} />
                                    </Button>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    startIcon={<UploadIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        justifyContent: 'flex-start',
                                        borderColor: '#e0e0e0',
                                        color: '#333',
                                        py: 1.5,
                                        '&:hover': { borderColor: '#c88b3e', backgroundColor: 'rgba(200, 139, 62, 0.04)' }
                                    }}
                                >
                                    <Box sx={{ textAlign: 'left', width: '100%' }}>
                                        <Typography variant="caption" display="block" color="textSecondary">
                                            Juego de Etiquetas (PDF/Imagen)
                                        </Typography>
                                        <Typography variant="body2" noWrap>
                                            {formData.etiquetasPdf ? formData.etiquetasPdf.name : 'Subir archivo...'}
                                        </Typography>
                                    </Box>
                                    <input type="file" hidden accept="application/pdf,image/*" name="etiquetasPdf" onChange={handleFileChange} />
                                </Button>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Comentarios o Datos Adicionales"
                                    name="comentarios"
                                    placeholder="Ingrese cualquier información relevante adicional..."
                                    value={formData.comentarios}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0', backgroundColor: '#f9f9f9' }}>
                        <Button
                            onClick={handleCloseModal}
                            sx={{ color: '#666', fontWeight: 'bold', textTransform: 'none' }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            sx={{
                                backgroundColor: isEditing ? '#c88b3e' : '#2b2b2b',
                                '&:hover': { backgroundColor: isEditing ? '#a67332' : '#444' },
                                borderRadius: '25px',
                                px: 4,
                                textTransform: 'none',
                                fontWeight: 'bold',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                            }}
                        >
                            {isEditing ? 'Guardar Cambios y Re-enviar' : 'Enviar Solicitud'}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDetailModal} onClose={handleCloseDetailModal} fullWidth maxWidth="sm">
                    <DialogTitle sx={{
                        background: selectedBrand?.estatus === 'RECHAZADA'
                            ? 'linear-gradient(45deg, #b71c1c 30%, #f44336 90%)'
                            : 'linear-gradient(45deg, #2b2b2b 30%, #444444 90%)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        py: 2
                    }}>
                        {selectedBrand?.estatus === 'RECHAZADA' ? <WarningIcon sx={{ color: '#ffcdd2' }} /> : <ViewIcon sx={{ color: '#c88b3e' }} />}
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {selectedBrand?.estatus === 'RECHAZADA' ? 'Solicitud Rechazada' : 'Detalle de Solicitud'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ mt: 0, p: 0 }}>
                        {selectedBrand && (
                            <>
                                {selectedBrand.estatus === 'RECHAZADA' && (
                                    <Box sx={{ backgroundColor: '#fff5f5', p: 2, display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #ffcdd2' }}>
                                        <ErrorIcon sx={{ color: '#f44336', fontSize: 40 }} />
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                                Atención: Se han detectado inconsistencias
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#d32f2f' }}>
                                                Por favor revise las observaciones al final de este panel y realice las correcciones necesarias.
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}

                                <Box sx={{ p: 3 }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <Box>
                                                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2b2b2b' }}>
                                                        {selectedBrand.nombre_marca || 'Marca no identificada'}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                                        <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', color: '#c88b3e' }}>
                                                            {selectedBrand.tipo_marca}
                                                        </Typography>
                                                        <Divider orientation="vertical" flexItem sx={{ height: 12, my: 'auto' }} />
                                                        <Typography variant="caption" color="textSecondary">
                                                            Folio: {selectedBrand.folio}
                                                        </Typography>
                                                        <Divider orientation="vertical" flexItem sx={{ height: 12, my: 'auto' }} />
                                                        <HistoryIcon sx={{ fontSize: 14, color: '#666' }} />
                                                        <Typography variant="caption" color="textSecondary">
                                                            {new Date(selectedBrand.fecha_creacion).toLocaleDateString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                {getStatusIcon(selectedBrand.estatus)}
                                            </Box>
                                            <Divider sx={{ mt: 2 }} />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ fontWeight: 'bold' }}>
                                                TIPO DE INFORME
                                            </Typography>
                                            <Typography variant="body1" sx={{ fontWeight: 'medium', mt: 0.5 }}>
                                                {selectedBrand.tipo_informe}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ fontWeight: 'bold' }}>
                                                ESTADO ACTUAL
                                            </Typography>
                                            <Typography variant="body1" sx={{ fontWeight: 'medium', mt: 0.5 }}>
                                                {selectedBrand.estatus}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                MOTIVOS DE REVISIÓN
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                {selectedBrand.cambio_presentacion && (
                                                    <Chip label="Cambio de presentación" size="small" sx={{ backgroundColor: 'rgba(200, 139, 62, 0.1)', color: '#c88b3e', fontWeight: 'bold' }} />
                                                )}
                                                {selectedBrand.cambio_pais && (
                                                    <Chip label="Cambio de país" size="small" sx={{ backgroundColor: 'rgba(200, 139, 62, 0.1)', color: '#c88b3e', fontWeight: 'bold' }} />
                                                )}
                                                {selectedBrand.cambio_destino && (
                                                    <Chip label="Cambio de destino" size="small" sx={{ backgroundColor: 'rgba(200, 139, 62, 0.1)', color: '#c88b3e', fontWeight: 'bold' }} />
                                                )}
                                                {selectedBrand.otros && (
                                                    <Chip label="Otros" size="small" sx={{ backgroundColor: 'rgba(200, 139, 62, 0.1)', color: '#c88b3e', fontWeight: 'bold' }} />
                                                )}
                                                {!selectedBrand.cambio_presentacion && !selectedBrand.cambio_pais && !selectedBrand.cambio_destino && !selectedBrand.otros && (
                                                    <Typography variant="body2" color="textSecondary">Sin motivos especificados</Typography>
                                                )}
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                DOCUMENTACIÓN ADJUNTA
                                            </Typography>
                                            <Grid container spacing={2}>
                                                {selectedBrand.solicitud_documentacion?.map((doc, idx) => (
                                                    <Grid item xs={12} sm={6} key={idx}>
                                                        <Paper variant="outlined" sx={{
                                                            p: 1.5,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 1.5,
                                                            cursor: 'pointer',
                                                            borderRadius: 2,
                                                            '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#c88b3e' }
                                                        }}>
                                                            <FileIcon sx={{ color: '#c88b3e' }} />
                                                            <Box>
                                                                <Typography variant="caption" display="block" color="textSecondary">
                                                                    {doc.tipo_documento === 'COMPROBANTE_PAGO' ? 'Pago' : 'Etiquetas'}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }} noWrap>{doc.nombre_archivo}</Typography>
                                                            </Box>
                                                        </Paper>
                                                    </Grid>
                                                ))}
                                                {(!selectedBrand.solicitud_documentacion || selectedBrand.solicitud_documentacion.length === 0) && (
                                                    <Grid item xs={12}>
                                                        <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                                                            No hay documentos adjuntos.
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>

                                        {selectedBrand.estatus === 'RECHAZADA' && selectedBrand.solicitud_validacion_resultados && (
                                            <Grid item xs={12}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 1, gap: 1 }}>
                                                    <ObsIcon sx={{ color: '#f44336', fontSize: 20 }} />
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#f44336' }}>
                                                        DETALLE POR CORREGIR
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{ mb: 2, borderColor: '#ffcdd2' }} />
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                    {selectedBrand.solicitud_validacion_resultados.filter(r => r.cumple == false)
                                                        .map((rev, idx) => (
                                                            <Paper
                                                                key={idx}
                                                                elevation={0}
                                                                sx={{
                                                                    p: 2,
                                                                    border: '1px solid #ffcdd2',
                                                                    borderLeft: '6px solid #f44336',
                                                                    backgroundColor: '#fffcfc',
                                                                    borderRadius: 2,
                                                                    position: 'relative',
                                                                    transition: 'all 0.2s',
                                                                    '&:hover': { boxShadow: '0 4px 12px rgba(244, 67, 54, 0.1)', transform: 'translateY(-2px)' }
                                                                }}
                                                            >
                                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                                                    <ErrorIcon sx={{ fontSize: 16, color: '#f44336' }} />
                                                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                                                        Observación {rev.cat_protocolo_items.descripcion_requisito}
                                                                    </Typography>
                                                                </Box>
                                                                <Typography variant="body2" sx={{ color: '#555', pl: 3, lineBreak: 'anywhere' }}>
                                                                    {rev.observacion}
                                                                </Typography>
                                                            </Paper>
                                                        ))
                                                    }
                                                </Box>
                                            </Grid>
                                        )}

                                        <Grid item xs={12}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                COMENTARIOS ADICIONALES
                                            </Typography>
                                            <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#fcfcfc', borderRadius: 2, borderStyle: 'dashed' }}>
                                                <Typography variant="body2" sx={{ fontStyle: selectedBrand.comentarios_adicionales ? 'normal' : 'italic', color: selectedBrand.comentarios_adicionales ? '#333' : '#999' }}>
                                                    {selectedBrand.comentarios_adicionales || 'Sin comentarios adicionales.'}
                                                </Typography>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0', backgroundColor: '#f9f9f9' }}>
                        <Button
                            onClick={selectedBrand?.estatus === 'RECHAZADA' ? () => handleEditRequest(selectedBrand) : handleCloseDetailModal}
                            variant="contained"
                            sx={{
                                backgroundColor: selectedBrand?.estatus === 'RECHAZADA' ? '#f44336' : '#2b2b2b',
                                '&:hover': { backgroundColor: selectedBrand?.estatus === 'RECHAZADA' ? '#d32f2f' : '#444' },
                                borderRadius: '25px',
                                px: 4,
                                textTransform: 'none',
                                fontWeight: 'bold'
                            }}
                        >
                            {selectedBrand?.estatus === 'RECHAZADA' ? 'Corregir y Re-enviar' : 'Cerrar Detalles'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </div>
    );
};

export default InformacionComercial;
